import React, { useState } from 'react';
import { Checkbox } from 'carbon-components-react';

const BooleanFormControl = (props) => {
  const [isChecked, setIsChecked] = useState(props.formData === true);
  const noLegend = props.uiSchema.noLegend;
  let label = props.schema.title;

  if (props.required) label += ' *';

  const onChange = (isChecked) => {
    setIsChecked(isChecked);
    props.onChange(isChecked);
  };

  return (
    <div className='form-control_checkbox-container'>
      {!noLegend && (<legend className='bx--label'>&nbsp;</legend>)}
      <Checkbox
        id={props.idSchema.$id}
        labelText={label}
        wrapperClassName='form-item_checkbox'
        onChange={onChange}
        defaultChecked={isChecked}
        disabled={props.schema.readOnly}
      />
    </div>
  );
};

export default BooleanFormControl;
